import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import { NotificationProvider } from '@hm-group/bads-react'
import { variables } from '@hm-group/bads-utilities'
import { getMsalInstance } from './services/msalConfig'
import { AppContextProvider } from './context/AppContext'
import { App } from './components/App/App'
import '@hm-group/bads-react/style.css';
import './index.css'

function injectBadsColorTokens(): void {
  const root = document.documentElement;
  const { colour } = variables;

  // Primary scale — neutral grays
  root.style.setProperty('--bads-color-primary-30', colour.neutral['30']);
  root.style.setProperty('--bads-color-primary-120', colour.text.secondary);

  // Secondary scale — lighter neutrals
  root.style.setProperty('--bads-color-secondary-10', colour.neutral['2']);
  root.style.setProperty('--bads-color-secondary-20', colour.neutral['5']);
  root.style.setProperty('--bads-color-secondary-30', colour.neutral['10']);
  root.style.setProperty('--bads-color-secondary-40', colour.neutral['10']);
  root.style.setProperty('--bads-color-secondary-90', colour.neutral['30']);
  root.style.setProperty('--bads-color-secondary-110', colour.neutral['10']);
  root.style.setProperty('--bads-color-secondary-120', colour.neutral['20']);

  // Semantic tokens
  root.style.setProperty('--bads-color-background-surface', colour.background.primary);
  root.style.setProperty('--bads-color-border-subtle', colour.border.divider);
  root.style.setProperty('--bads-color-text-primary', colour.text.primary);

  // Signal — information (blue)
  root.style.setProperty('--bads-color-signal-information-10', colour.accent.blue['10']);
  root.style.setProperty('--bads-color-signal-information-30', colour.accent.blue['30']);
  root.style.setProperty('--bads-color-signal-information-120', colour.accent.blue['120']);
}

injectBadsColorTokens();

const msalInstance = getMsalInstance()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <NotificationProvider>
          <AppContextProvider>
            <App />
          </AppContextProvider>
        </NotificationProvider>
      </MsalProvider>
    </BrowserRouter>
  </StrictMode>,
)
